import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.questionnaires.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.questionnaires.error;
export const questionnairesDataResponse = (state: RootState) =>
  state.questionnaires.questionnairesResponse;
